export default "__VITE_ASSET__CsPQENBT__"